<template>
  <FormPage
    title="Новая компания"
    description="Создайте компанию-исполнителя. ИНН и название можно подтянуть из DaData."
  >
    <CompanyForm @sendForm="onSubmit" @closeForm="onCancel" />
  </FormPage>
</template>

<script>
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { createToaster } from '@meforma/vue-toaster'
import CompanyForm from '@/components/forms/CompanyForm.vue'

const toaster = createToaster()

export default {
  name: 'CompanyCreatePage',
  components: { CompanyForm },
  setup() {
    const router = useRouter()
    const store = useStore()

    const onSubmit = async ({ model, form }) => {
      const created = await store.dispatch('apiStorage/addItem', { model, form })
      if (!created) return
      toaster.success('Компания добавлена')
      const id = created.id
      if (id != null) {
        router.push({ name: 'CompanyDetail', params: { id: String(id) } })
      } else {
        router.push({ name: 'Company' })
      }
    }

    const onCancel = () => {
      router.push({ name: 'Company' })
    }

    return { onSubmit, onCancel }
  },
}
</script>
